import { render } from "./StatusStepInfo.vue?vue&type=template&id=29a25da6&scoped=true"
import script from "./StatusStepInfo.vue?vue&type=script&lang=js"
export * from "./StatusStepInfo.vue?vue&type=script&lang=js"

import "./StatusStepInfo.vue?vue&type=style&index=0&id=29a25da6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a25da6"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QList,QItem,QItemSection});
